export const LayerShapeMixin = {
    props: {
        breakpoint: {
            type: Number,
            required: true,
        },
        shape: {
            type: Object,
            required: true,
        },
        aspectRatio: {
            type: Number,
            required: true,
        },
        extraScale: {
            type: Number,
            required: true,
        },
        imageSize: {
            type: Object,
            required: true,
        },
        currentLocale: {
            type: Number | String,
            required: false,
        },
        zoom: {
            type: Number,
            required: true,
        },
        shapeCreatedCallback: {
            type: Function,
            required: false,
        },
    },
    data() {
        return {
            lang: null,
            _unsubscribe: null,
        };
    },
    created() {
        if (this.shapeCreatedCallback) {
            this._unsubscribe = this.shapeCreatedCallback(({ locale, id }) => {
                if (id !== this.shape.layerId) return;
                this.lang = locale;
            });
        }
    },
    beforeDestroy() {
        if (this._unsubscribe) {
            this._unsubscribe();
        }
    },

    computed: {
        contentTranslate() {
            return (
                this.shape.translations.content[
                    "langs-" + this.computedLocale
                ] ??
                this.shape.translations.content[
                    "langs-" + this.currentLocale
                ] ??
                Object.values(this.shape.translations.content)[0]
            );
        },
        computedLocale() {
            return this.lang ? this.lang : this.currentLocale;
        },
        normalizeScale() {
            return Number((this.imageSize.width / 1400).toFixed(2));
        },

        defaultScale() {
            if (this.selected) return 1;
            const defaultScale =
                this.normalizeScale * this.zoom * this.extraScale;
            return Number(Math.min(defaultScale, 1).toFixed(2));
        },

        scale() {
            return Number(
                Math.min(this.defaultScale / this.zoom, 1).toFixed(2)
            );
        },
        selected() {
            return this.shape?.state?.isSelected || false;
        },
        isHover() {
            return this.shape?.state?.value == "hover" || false;
        },
        isActive() {
            return this.shape?.state?.value == "active" || false;
        },
        isStatic() {
            return !!this.shape?.static;
        },
        isVisible() {
            return !!(this.shape?.visible & this.breakpoint);
        },
        style() {
            return this.isStatic
                ? "default"
                : this.shape?.state?.value || "default";
        },
    },

    methods: {
        handleMouseOver(event) {
            this.$emit("handleMouseOverVue", event);
        },
        handleMouseLeave(event) {
            this.$emit("handleMouseLeaveVue", event);
        },
        handleMouseDown(event) {
            this.$emit("handleMouseDownVue", event);
        },
        handleMouseUp(event) {
            this.$emit("handleMouseUpVue", event);
        },
        handleContextMenu(event) {
            this.$emit("handleContextMenuVue", event);
        },
        handleFrameClick(event) {
            this.$emit("handleFrameClickVue", event);
        },
        handleMouseMove(event) {
            this.$emit("handleMouseMoveVue", event);
        },
    },
};
